import React from "react";
import './KnowledgeBase.css';

const KnowledgeBase = () => {
  return (
    <div><p>KnowledgeBase</p></div>
  )
}

export default KnowledgeBase;